import {FC, useEffect, useState} from 'react'

import { Modal, useModal } from '.'
import { FormMessageError } from '..'
import { useAuth } from '../../../hooks'
import {storage} from "../../../services";

const ModalAuth:FC = () => {
  const modal = useModal()
  const userCurrent = useAuth()
  const [title, setTitle] = useState("La sesión ha expirado");

  useEffect(() => {
    sessionExpiredValid()
      const otherSession = storage.get('otherSession') ?? false;
       if(otherSession) {
           storage.remove('otherSession');
           setTitle("Por motivos de seguridad, debemos cerrar tu sesión, ya que has ingresado con tu cuenta en otro dispositivo. Para cualquier duda escríbenos a Portal@indisa.cl");
       }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const sessionExpiredValid = () => {
    const isUserCurrentSessionExpired = userCurrent.isUserSessionExpired()

   if(isUserCurrentSessionExpired) {
      modal.open()
      userCurrent.logout()
    }
  }

  const onClose = () => modal.close()

  return (
    <Modal show={modal.show} maxWidth="345px" onClose={onClose}>
      <FormMessageError
        title= {title}
        className="py-80 px-30"
        onClick={onClose}
      />
    </Modal>
  )
}

export { ModalAuth }